import React from 'react';
import { FormTextarea, FormGroup, FormFeedback } from 'shards-react';
import { useTranslation } from 'react-i18next';
import './style.css';
const TextArea = (props) => {
  const { inputHasErrors, label } = props;
  const { t, i18n } = useTranslation();
  return (
    <FormGroup>
      {label && <label className="capitalize-first-letter">{label}</label>}
      <FormTextarea invalid={inputHasErrors} {...props} />
      <FormFeedback invalid>{t(inputHasErrors)}</FormFeedback>
    </FormGroup>
  );
};

export default TextArea;
